<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      title="Création d'un Lot">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <parking-form
          @submit="createParking"
          :source-loading="loading"
          :source-lot-program="lotProgram"></parking-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import LotMixin from '@/components/lots/LotMixin'

export default {
  name: 'ParkingDuplicate',
  components: {
    ParkingForm: () => import('./ParkingForm')
  },
  mixins: [LotMixin]
}
</script>
